// extracted by mini-css-extract-plugin
module.exports = {"border":"_38h27cB25OlSFlfAzaYJs5","color_black":"G-w98L8fjufDnMh7zUO9","svg":"wjA_uVANUltZQBzsOTAyZ"};